export default {
  title: '隱私政策',
  docTitle: 'BetCorgi 隱私政策',
  docSubtitle: '瞭解我們如何保護和使用您的信息',
  intro: '我們遵循必要、明確和安全原則處理您的信息。本政策說明信息如何被收集、使用、保存及保護。',
  s1Title: '我們收集的信息',
  s1Body:
    '可能包括賬號資料、綁定手機或郵箱、身份核驗資料、設備與登錄信息、充值提現記錄、收款賬戶、操作日誌及為完成服務所必需的其他信息。',
  s2Title: '信息使用目的',
  s2Body:
    '用於創建和管理賬號、完成交易與身份核驗、保障賬號及資金安全、識別欺詐風險、提供客服、處理爭議、優化產品以及履行適用的合規義務。',
  s3Title: '信息共享',
  s3Body:
    '僅在完成支付、身份認證、技術服務、風險控制或依法配合監管所必要的範圍內，與經審慎選擇的合作方共享。我們不會出售您的個人信息。',
  s4Title: '存儲與安全',
  s4Body:
    '我們採取訪問控制、傳輸加密、風險監測及數據最小化等措施保護信息，並在實現目的或法律要求的必要期限內保存；期滿後將刪除或匿名化處理。',
  s5Title: '您的權利',
  s5Body:
    '您可以在賬號或安全中心查看、更正部分資料，管理綁定方式及授權；也可聯繫客服申請訪問、更正、刪除或註銷賬號。為保障安全，我們可能先核驗身份。',
  s6Title: '設備信息與本地存儲',
  s6Body:
    '為保持登錄狀態、保存界面偏好和改善體驗，可能使用 Cookie 或本地存儲。關閉後部分功能可能無法正常工作，您可通過設備或瀏覽器設置進行管理。',
  s7Title: '未成年人保護',
  s7Body:
    '平臺僅向已滿 18 週歲的用戶提供服務。若發現未成年人信息被誤收集，請聯繫我們核實並及時處理。',
  s8Title: '政策更新與聯繫',
  s8Body:
    '重大變更將通過顯著提示或站內消息告知。若對個人信息處理有疑問或希望行使相關權利，可聯繫在線客服。',
  done: '我已閱讀',
}
